export default "/ui/images/blackmarker.svg";